/*
  React Toastify requires this as a prop to use a custom animation for their
  toasts.

  This basically chooses which to and from CSS classes to add during each stage
  of the toast's lifecycle.
*/

import { cssTransition } from 'react-toastify';
import { css, keyframes } from 'styled-components';
import { ToastClassNames } from "../constants/index.js";
export var StyledKeyframesEnter = keyframes(["from{opacity:0;transform:scale(0.95) translate3d(0,110%,0);visibility:visible;}to{opacity:1;transform:scale(1) translate3d(0,0,0);}"]);
export var StyledKeyframesExit = keyframes(["from{opacity:1;transform:scale(1) translate3d(0,0,0);}to{opacity:0;transform:scale(0.95) translate3d(0,50%,0);}"]);
export var ANIMATION_STYLES = css(["", "{animation-delay:0.3s;animation-duration:0.2s;animation-fill-mode:both;animation-name:", ";animation-timing-function:var(--transition-easing);}", "{animation-duration:0.2s;animation-fill-mode:both;animation-name:", ";animation-timing-function:var(--transition-easing);}"], ToastClassNames.CUSTOM_TRANSITION_ENTER, StyledKeyframesEnter, ToastClassNames.CUSTOM_TRANSITION_EXIT, StyledKeyframesExit);
var Transition = cssTransition({
  collapse: false,
  enter: "".concat(ToastClassNames.ANIMATE_ANIMATED, " ").concat(ToastClassNames.CUSTOM_TRANSITION_ENTER).replaceAll('.', ''),
  exit: "".concat(ToastClassNames.ANIMATE_ANIMATED, " ").concat(ToastClassNames.CUSTOM_TRANSITION_EXIT).replaceAll('.', '')
});
export default Transition;